<template>
  <!--页面加载动画-->
  <div class="select-box">
    <span class="defaultTxt" @click="showTime">
    {{time | showdate}}
    <i class="iconfont iconiconfontriqi"></i>
    </span>
    <van-popup v-model="showLayer" position="bottom">
      <van-datetime-picker
      v-model="pickerVisible"
      type="date"
      :min-date="startDate"
      :max-date="endDate"
      @confirm="dateConfirm"
      @cancel="showLayer=false"
      :formatter="formatter"
    />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: "请选择日期",
      pickerVisible:'',
      showLayer:false,//是否显示弹窗
    };
  },
  props: ["selectData"],
  computed:{
    startDate(){
      let beginDate=this.selectData && this.selectData.beginDate
      ? new Date(this.selectData.beginDate)
      : new Date("1949-01-01");
      return beginDate
    },
    endDate(){
      let endDate=this.selectData && this.selectData.endDate
      ? new Date(this.selectData.endDate)
      : new Date("2050-12-12");
      return endDate;
    },
  },
  mounted() {
      if(this.selectData.elementValue){
          this.pickerVisible=this.selectData.elementValue?new Date(this.selectData.elementValue):new Date();
          this.time=this.selectData.elementValue;
      }
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`
      }else if (type === 'day') {
        return `${val}日`
      }
      return val;
    },
    showTime(i) {
      //按钮选择
      setTimeout(_=>{
        //按钮选择
        this.showLayer=true;
      },100)
    },
    dateConfirm(t,n){
      this.time=this.formatDate(t);
      console.log(this.time);
      this.showLayer=false;
      this.getResult();
    },
    getResult() {
      //选择后回调到父组件
      let value = this.time;
      this.selectData.elementValue=value;
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    },
    formatDate(secs) {
        var t = new Date(secs)
        var year = t.getFullYear()
        var month = t.getMonth() + 1
        if (month < 10) { month = '0' + month }
        var date = t.getDate()
        if (date < 10) { date = '0' + date }
        var hour = t.getHours()
        if (hour < 10) { hour = '0' + hour }
        var minute = t.getMinutes()
        if (minute < 10) { minute = '0' + minute }
        var second = t.getSeconds()
        if (second < 10) { second = '0' + second }
        return year + '-' + month + '-' + date
    }
  },
  watch: {
    selectData(newVal) {
      if(this.selectData.elementValue){
          this.pickerVisible=this.selectData.elementValue?new Date(this.selectData.elementValue):new Date();
          this.time=this.selectData.elementValue;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box {
  width: 100%;
  height: 100%;
  .iconfont {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 36px;
  color: #0084ff;
  opacity: 0.7;
}
}
.defaultTxt {
  width: 100%;
  line-height: 40px;
  font-size: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 50px;
  display: inline-block;
}

</style>